// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"8e7332c1","977":"9ad1b5a1"}[chunkId] + ".chunk.js";
};